import React, { Component } from 'react'



class OfficialTeamApplication extends Component {
    // 组件内部
    constructor(props) {
        super(props)
        this.state = {
            
        }

    }

    componentDidMount() {

    }

    // 页面渲染区
    render() {

        return (
            <div className="teamApplication" >
               
                这是正式队申请
            </div>

        )
    }
}



export default OfficialTeamApplication



// WEBPACK FOOTER //
// ./src/routes/teamApplication/OfficialTeamApplication.jsx